/* eslint-disable react-hooks/exhaustive-deps */
import { useMediaQuery, Grid, Box, useTheme, Typography, Button, Container, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomRightImage from "@components/CustomRightImagev2";
import { useLazyGetTaxSystemConfigQuery } from "@api/applications";
import { useEffect, useState } from "react";
import { GuaranteeConfigStruture, TaxSystemConfigResponse } from "@interfaces/index";
import { amountToText, calculateAmountMonthly, formatCurrency } from "@helpers/funciones";
import icon_check from "@assets/img/icon_check_cotizador.svg";
import { CustomDialog } from "@components/CustomDialog";
import { StyledSlider } from "@components/CustomSlider";
import { ButtonTypeSelected } from "@components/ButtonTypeSelected";
import IconInfo from "@components/Images/IconInfo";
import { useLazyGetGuaranteeConfigQuery } from "@api/catalogs";
import useInterfaceConfig from "@hooks/useInterfaceConfig";

const CotizadorArraCapital = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isShortScreen = useMediaQuery("(max-height:820px)");
  const interfaceConfig = useInterfaceConfig();

  const [getTaxSystemConfig] = useLazyGetTaxSystemConfigQuery();
  const [getGuaranteeTypeConfig] = useLazyGetGuaranteeConfigQuery();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [configPM, setConfigPM] = useState<TaxSystemConfigResponse | null>(null);
  const [configPFAE, setConfigPFAE] = useState<TaxSystemConfigResponse | null>(null);
  const [personType, setPersonType] = useState<string>("PM");

  const [guaranteeType, setGuaranteeType] = useState<string>("");

  const [error, setError] = useState<boolean>(false);

  const [amountMarks, setAmountMarks] = useState<{ value: number; label: string }[]>([]);
  const [termMarks, setTermMarks] = useState<{ value: number; label: string }[]>([]);
  const [guaranteeConfigListPM, setGuaranteeConfigListPM] = useState<GuaranteeConfigStruture[]>([]);
  const [guaranteeConfigListPFAE, setGuaranteeConfigListPFAE] = useState<GuaranteeConfigStruture[]>([]);

  const [guaranteeConfig, setGuaranteeConfig] = useState<GuaranteeConfigStruture[]>([]);

  const [cotizadorConfig, setCotizadorConfig] = useState<TaxSystemConfigResponse>({
    id: "",
    code: "",
    product_id: "",
    minAmount: 0,
    maxAmount: 0,
    stepAmount: 0,
    minTerm: 0,
    maxTerm: 0,
    stepTerm: 0,
    defaultAmount: 0,
    defaultTerm: 0,
    tax_system_type: "",
  });

  const [selectedAmount, setSelectedAmount] = useState<number>(cotizadorConfig.defaultAmount);
  const [selectedTerm, setSelectedTerm] = useState<number>(cotizadorConfig.defaultTerm);
  const [monthlyRate, setMonthlyRate] = useState<number>(0);

  const [hoverDialogOpen, setHoverDialogOpen] = useState(false);

  const handleOpenModal = () => setHoverDialogOpen(true);
  const handleCloseModal = () => setHoverDialogOpen(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const [responsePM, responsePFAE, responseGuaranteeConfigPM, responseGuaranteeConfigPFAE] = await Promise.all([
          getTaxSystemConfig("CSAC1").unwrap(),
          getTaxSystemConfig("CSAC2").unwrap(),
          getGuaranteeTypeConfig({ tax_code: "CSAC1" }).unwrap(),
          getGuaranteeTypeConfig({ tax_code: "CSAC2" }).unwrap(),
        ]);
        setConfigPM(responsePM);
        setConfigPFAE(responsePFAE);
        setGuaranteeConfigListPM(responseGuaranteeConfigPM);
        setGuaranteeConfigListPFAE(responseGuaranteeConfigPFAE);
      } catch (error) {
        console.error("Error fetching tax system configs", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (personType === "PM" && configPM) {
      setCotizadorConfig(configPM);
    } else if (personType === "PFAE" && configPFAE) {
      setCotizadorConfig(configPFAE);
    }
    setGuaranteeType("");
  }, [personType, configPM, configPFAE]);

  useEffect(() => {
    if (personType === "PM" && guaranteeConfigListPM) {
      setGuaranteeConfig(guaranteeConfigListPM);
    } else if (personType === "PFAE" && guaranteeConfigListPFAE) {
      setGuaranteeConfig(guaranteeConfigListPFAE);
    }
  }, [personType, guaranteeConfigListPM, guaranteeConfigListPFAE]);

  useEffect(() => {
    const { minAmount, maxAmount, stepAmount, minTerm, maxTerm, stepTerm, defaultAmount, defaultTerm } =
      cotizadorConfig;

    if (minAmount < maxAmount && stepAmount > 0) {
      const marks = [];

      marks.push({ value: minAmount, label: amountToText(minAmount) });
      marks.push({ value: maxAmount, label: amountToText(maxAmount) });

      setAmountMarks(marks);
    }

    if (minTerm < maxTerm && stepTerm > 0) {
      const marks = [];

      for (let i = minTerm; i <= maxTerm; i += stepTerm) {
        marks.push({ value: i, label: `${i}` });
      }

      setTermMarks(marks);
      setSelectedAmount(defaultAmount);
      setSelectedTerm(defaultTerm);
    }
  }, [cotizadorConfig]);

  useEffect(() => {
    if (selectedAmount && selectedTerm) {
      const monthly = calculateAmountMonthly(
        selectedAmount,
        selectedTerm,
        interfaceConfig?.interest_rate,
        interfaceConfig?.comision,
        interfaceConfig?.iva,
      );
      setMonthlyRate(monthly);
    }
  }, [selectedAmount, selectedTerm, interfaceConfig?.interest_rate, interfaceConfig?.comision, interfaceConfig?.iva]);

  const setConditions = () => {
    if (!cotizadorConfig.product_id || !selectedAmount || !selectedAmount || !monthlyRate || !guaranteeType) {
      setError(true);
      return;
    }
    const sourceCode = sessionStorage.getItem("source_code");
    console.log(guaranteeConfig);
    const selectedGuarantee = guaranteeConfig.find(
      (item) => item.guarantee_type.code === guaranteeType,
    )?.guarantee_type_id;

    console.log(selectedGuarantee);

    let urlPortal = `/producto/creditosimple/crear_cuenta?tax_system_id=${cotizadorConfig.id}&product_id=${cotizadorConfig.product_id}&person_type=${cotizadorConfig.code}&loan_amount=${selectedAmount}&loan_term=${selectedTerm}&tax_system_type=${cotizadorConfig.tax_system_type}&guarantee_types=${selectedGuarantee}&guarantee_type_code=${guaranteeType}`;
    if (sourceCode) {
      urlPortal += `&source_code=${sourceCode}`;
    }
    navigate(urlPortal);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sourceCode = params.get("code");

    if (sourceCode) {
      sessionStorage.setItem("source_code", sourceCode);
    } else {
      sessionStorage.removeItem("source_code");
    }
  }, []);

  useEffect(() => {
    if (guaranteeType !== "") {
      setError(false);
    }
  }, [guaranteeType]);

  return (
    <>
      <Grid container height="100%">
        <Grid item xs={12} md={8}>
          <Container maxWidth={"sm"}>
            <Typography fontWeight={500} variant="h3" mt={4} color={theme?.palette?.primary?.dark} textAlign={"center"}>
              Cotizador
            </Typography>

            <Box>
              <Box>
                <Typography
                  fontWeight={500}
                  fontSize={"16px"}
                  mt={1}
                  color={theme?.palette?.primary?.dark}
                  textAlign={"center"}
                >
                  Selecciona tu régimen fiscal
                </Typography>

                <Grid container spacing={isMobileOrTablet ? 0 : 2} mt={1} mr={isMobileOrTablet ? 1 : 0}>
                  <Grid item xs={6} md={6} display="flex" justifyContent={isMobileOrTablet ? "center" : "flex-end"}>
                    {!isLoading ? (
                      <ButtonTypeSelected
                        title="Persona Moral"
                        onClick={() => setPersonType("PM")}
                        isSelected={personType === "PM"}
                        isMovile={isMobileOrTablet}
                        height={isShortScreen ? "60px" : "70px"}
                        heightMoviles="60px"
                        width={isShortScreen ? "170px" : "190px"}
                        widthMoviles="130px"
                        icon={icon_check}
                        width_icon="22px"
                        height_icon="22px"
                        font_size={isShortScreen ? "12px" : "14px"}
                        top_icon="-12px"
                        font_size_movil="11px"
                      />
                    ) : (
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={isMobileOrTablet ? 150 : 190}
                        height={isMobileOrTablet ? 60 : 70}
                      />
                    )}
                  </Grid>
                  <Grid item xs={6} md={6} display="flex" justifyContent={isMobileOrTablet ? "center" : "flex-start"}>
                    {!isLoading ? (
                      <ButtonTypeSelected
                        title="Persona física con actividad empresarial"
                        onClick={() => setPersonType("PFAE")}
                        isSelected={personType === "PFAE"}
                        isMovile={isMobileOrTablet}
                        height={isShortScreen ? "60px" : "70px"}
                        heightMoviles="60px"
                        width={isShortScreen ? "170px" : "190px"}
                        widthMoviles="130px"
                        icon={icon_check}
                        width_icon="22px"
                        height_icon="22px"
                        font_size={isShortScreen ? "12px" : "14px"}
                        top_icon="-12px"
                        font_size_movil="11px"
                      />
                    ) : (
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={isMobileOrTablet ? 150 : 190}
                        height={isMobileOrTablet ? 60 : 70}
                      />
                    )}
                  </Grid>
                </Grid>
              </Box>

              <Box mt={4} ml={isMobileOrTablet ? 3 : 1} mr={isMobileOrTablet ? 3 : 1}>
                <Typography
                  fontWeight={500}
                  fontSize={"16px"}
                  color={theme?.palette?.primary?.dark}
                  textAlign={"center"}
                >
                  Selecciona el monto
                </Typography>

                <Typography
                  fontWeight={700}
                  fontSize={"13px"}
                  mt={1}
                  color={theme?.palette?.primary?.main}
                  textAlign={"center"}
                >
                  {amountToText(selectedAmount)}
                </Typography>

                {!isLoading ? (
                  <StyledSlider
                    aria-label="amount"
                    min={cotizadorConfig.minAmount}
                    max={cotizadorConfig.maxAmount}
                    step={cotizadorConfig.stepAmount}
                    marks={amountMarks}
                    defaultValue={cotizadorConfig.defaultAmount}
                    value={selectedAmount}
                    onChange={(_event, newValue) => setSelectedAmount(newValue as number)}
                  />
                ) : (
                  <Skeleton variant="rectangular" animation="wave" />
                )}
              </Box>

              <Box mb={1} ml={isMobileOrTablet ? 3 : 1} mr={isMobileOrTablet ? 3 : 1}>
                <Typography
                  fontWeight={500}
                  fontSize={"16px"}
                  mb={2}
                  color={theme?.palette?.primary?.dark}
                  textAlign={"center"}
                >
                  Selecciona el plazo en meses
                </Typography>

                {!isLoading ? (
                  <StyledSlider
                    aria-label="term"
                    min={cotizadorConfig.minTerm}
                    max={cotizadorConfig.maxTerm}
                    step={1}
                    defaultValue={cotizadorConfig.defaultTerm}
                    marks={termMarks}
                    value={selectedTerm}
                    onChange={(_event, newValue) => setSelectedTerm(newValue as number)}
                    valueLabelDisplay="on"
                  />
                ) : (
                  <Skeleton variant="rectangular" animation="wave" />
                )}
              </Box>

              <Box mt={2}>
                <Typography
                  fontWeight={500}
                  fontSize={"16px"}
                  mt={1}
                  color={theme?.palette?.primary?.dark}
                  textAlign={"center"}
                >
                  Selecciona tu tipo de Garantía{" "}
                  <IconInfo fill={theme.palette.primary.main} onClick={handleOpenModal} style={{ cursor: "pointer" }} />
                </Typography>

                <Grid container spacing={isMobileOrTablet ? 0 : 2} mt={1} mr={isMobileOrTablet ? 1 : 0}>
                  {guaranteeConfig.map((guarantee, index) => (
                    <Grid
                      key={guarantee.guarantee_type_id}
                      item
                      xs={6}
                      md={6}
                      display="flex"
                      justifyContent={isMobileOrTablet ? "center" : index % 2 === 0 ? "flex-end" : "flex-start"}
                    >
                      {!isLoading ? (
                        <ButtonTypeSelected
                          title={guarantee.guarantee_type.name}
                          onClick={() => {
                            setGuaranteeType(guarantee.guarantee_type.code);
                          }}
                          isSelected={guaranteeType === guarantee.guarantee_type.code}
                          isMovile={isMobileOrTablet}
                          height={isShortScreen ? "60px" : "70px"}
                          heightMoviles="60px"
                          width={isShortScreen ? "170px" : "190px"}
                          widthMoviles="130px"
                          icon={icon_check}
                          width_icon="22px"
                          height_icon="22px"
                          font_size={isShortScreen ? "12px" : "14px"}
                          top_icon="-12px"
                          font_size_movil="11px"
                        />
                      ) : (
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          width={isMobileOrTablet ? 150 : 190}
                          height={isMobileOrTablet ? 60 : 70}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
                {error && (
                  <>
                    <Typography fontWeight={400} fontSize={"12px"} mt={2} color={"#d32f2f"} textAlign={"center"}>
                      Selecciona un tipo de garantía
                    </Typography>
                  </>
                )}
              </Box>

              <Typography
                fontWeight={700}
                fontSize={"16px"}
                color={theme?.palette?.primary?.main}
                textAlign={"center"}
                m={4}
              >
                Pago mensual estimado*
              </Typography>

              <Typography
                mb={2}
                textAlign={"center"}
                variant="h4"
                fontWeight={theme?.palette?.fontWeights?.semibold}
                color={theme?.palette?.primary?.dark}
              >
                {isNaN(monthlyRate) || !isFinite(monthlyRate) ? "0" : formatCurrency(monthlyRate)}{" "}
                <Typography
                  variant="h5"
                  component={"span"}
                  fontWeight={theme?.palette?.fontWeights?.semibold}
                  color={theme?.palette?.primary?.dark}
                >
                  MXN
                </Typography>
              </Typography>

              <Typography
                textAlign={"center"}
                fontWeight={theme?.palette?.fontWeights?.light}
                color={theme?.palette?.primary?.dark}
                mt={2}
                mb={2}
              >
                <small>
                  *Esta simulación es para fines demostrativos y está sujeto a aprobación, las condiciones como la tasa,
                  el monto del crédito, o la comisión por apertura, podrían cambiar dependiendo el perfil y la situación
                  actual del solicitante.
                </small>
              </Typography>

              <Box display="flex" justifyContent="center" mb={2}>
                <Button variant="contained" onClick={setConditions} disabled={isLoading}>
                  Continuar
                </Button>
              </Box>
            </Box>
          </Container>
        </Grid>
        {!isMobileOrTablet && (
          <Grid item xs={12} md={4}>
            <CustomRightImage />
          </Grid>
        )}
      </Grid>

      <CustomDialog
        colorClose={theme?.palette?.primary?.main}
        open={hoverDialogOpen}
        onClose={handleCloseModal}
        itemTitle={""}
        itemContent={
          <>
            <Typography fontWeight={700} fontSize={"16px"} color={theme?.palette?.primary?.main} textAlign={"center"}>
              Garantía Vehicular
            </Typography>
            <Typography fontWeight={300} fontSize={"16px"} color={theme?.palette?.primary?.dark} textAlign={"center"}>
              Garantía 1:1
              <br />
              No se retiene el vehículo, se admiten Autos, SUVs, Camionetas, Vans y Tractos.
            </Typography>
            <hr style={{ border: `1px solid ${theme?.palette?.primary?.main}` }} />
            <Typography fontWeight={700} fontSize={"16px"} color={theme?.palette?.primary?.main} textAlign={"center"}>
              Garantía Inmobiliaria
            </Typography>

            <Typography fontWeight={300} fontSize={"16px"} color={theme?.palette?.primary?.dark} textAlign={"center"}>
              Garantía 3:1
              <br />
              Se admiten casas, departamentos, bodegas industriales, oficinas. No se admiten terrenos.
            </Typography>
          </>
        }
      />
    </>
  );
};
export default CotizadorArraCapital;
